import { Bar } from 'vue-chartjs';

export default {
  extends: Bar,
  props: {
    datasBarChart: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      ylabel: '%',
    };
  },
  mounted() {
    this.gradient = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 0, 500);
    this.gradient2 = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 0, 500);
    this.gradient3 = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 0, 500);
    this.gradient4 = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 0, 500);
    this.gradient5 = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 0, 500);

    this.gradient.addColorStop(0, 'rgba(4, 58, 70, 0.9)');
    this.gradient.addColorStop(0.5, 'rgba(4, 58, 70, 0.25)');
    this.gradient.addColorStop(1, 'rgba(4, 58, 70, 0)');

    this.gradient2.addColorStop(0, 'rgba(153, 55, 26, 0.9)');
    this.gradient2.addColorStop(0.5, 'rgba(153, 55, 26, 0.25)');
    this.gradient2.addColorStop(1, 'rgba(153, 55, 26, 0)');

    this.gradient3.addColorStop(0, 'rgba(255, 196, 30, 0.5)');
    this.gradient3.addColorStop(0.5, 'rgba(255, 196, 30, 0.25)');
    this.gradient3.addColorStop(1, 'rgba(255, 196, 30, 0)');

    this.gradient4.addColorStop(0, 'rgba(31, 85, 97, 0.9)');
    this.gradient4.addColorStop(0.5, 'rgba(31, 85, 97, 0.25)');
    this.gradient4.addColorStop(1, 'rgba(31, 85, 97, 0)');

    this.gradient5.addColorStop(0, 'rgba(210, 163, 73, 0.9)');
    this.gradient5.addColorStop(0.5, 'rgba(210, 163, 73, 0.25)');
    this.gradient5.addColorStop(1, 'rgba(210, 163, 73, 0)');

    this.renderChart(
      {
        labels: this.getReferrer(this.datasBarChart),
        datasets: [
          {
            label: 'Taux de rebond (en %)',
            data: this.getBounce(this.datasBarChart),
            backgroundColor: [
              this.gradient,
              this.gradient2,
              this.gradient3,
              this.gradient4,
              this.gradient3,
              this.gradient2,
              this.gradient1,
              this.gradient,
            ],
          },
        ],
      },
      {
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              gridLines: {
                display: false,
              },
              scaleLabel: {
                display: true,
                labelString: this.ylabel,
              },
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
      },
    );
  },
  methods: {
    getReferrer(periode) {
      const labels = [];
      for (let i = 0; i < periode.length; i++) {
        labels.push(periode[i][0]);
      }
      return labels;
    },
    getBounce(periode) {
      const datas = [];
      for (let i = 0; i < periode.length; i++) {
        datas.push(periode[i][1].slice(0, 4));
      }
      return datas
        .sort(function (a, b) {
          return a - b;
        })
        .reverse();
    },
  },
};
